import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import {Grid, Paper, styled} from '@mui/material';
import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import routes from '../../../../routes';
import Wrapper from './Wrapper';

const Link = styled(RouterLink)(() => ({
  cursor: 'pointer',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  textDecoration: 'none',
}));

const Option = ({children}) => (
  <Grid item xs={6} md={4} lg={3} display="flex" flexDirection="column">
    {children}
  </Grid>
)

const Item = styled(Paper)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  overflow: 'hidden',
}));

const Icon = styled('div')(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  padding: theme.spacing(2),

  '& svg': {
    height: 'auto',
    width: 80,
  }
}));

const Label = styled('h3')(({theme}) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  flex: 0,
  margin: 0,
  padding: theme.spacing(1),
  textAlign: 'center',
}));

const Reporting = () => {
  return (
    <Wrapper loading={false} crumbs={Wrapper.standardCrumbs}>
      <Grid container spacing={2} marginY={1}>
        <Option>
          <Link to={routes.reporting.profits}>
            <Item>
              <Icon><WorkOutlineIcon/></Icon>
              <Label>Profits</Label>
            </Item>
          </Link>
        </Option>
        <Option>
          <Link to={routes.reporting.subscriptionPayments}>
            <Item>
              <Icon><SubscriptionsIcon/></Icon>
              <Label>Subscription Payments</Label>
            </Item>
          </Link>
        </Option>
      </Grid>
    </Wrapper>
  );
}

export default Reporting;
